import React, { Component, Fragment } from "react";
import i18n from "../../../i18n";
import { withTranslation } from "react-i18next";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { route } from "../../../routes";
import {
  GelContentContainer,
  GelContentRow,
  GelContentColumn,
  TopNavigation,
  Button,
  Notice,
  HorizontalRule,
  FormErrorSummary,
  Loading,
  Accordion,
  withRouter,
  ButtonSecondary,
  Notices,
  Sanitize,
  FormUtility,
} from "cw-styleguide-react";
import DetailViewSchedule from "./DetailViewSchedule";
import Helmet from 'react-helmet';

class DetailView extends Component {
  generateJumpList() {
    let contents = [
      this.props.course.summary
        ? {
            url: "#summary",
            text: this.props.t("view.detail.subheadings.summary"),
          }
        : null,
      // this.props.course.requirements.length > 0 ? {url: '#requirements', text: this.props.t('view.detail.subheadings.requirements')} : null,
      this.props.course.content
        ? {
            url: "#content",
            text: this.props.t("view.detail.subheadings.content"),
          }
        : null,
      this.props.course.duration
        ? {
            url: "#duration",
            text: this.props.t("view.detail.subheadings.duration"),
          }
        : null,
      this.props.course.entry
        ? { url: "#entry", text: this.props.t("view.detail.subheadings.entry") }
        : null,
      this.props.course.enrolment
        ? {
            url: "#enrolment",
            text: this.props.t("view.detail.subheadings.enrolment"),
          }
        : null,
      this.props.course.additionalDetails
        ? {
            url: "#additionalDetails",
            text: this.props.t("view.detail.subheadings.additionalDetails"),
          }
        : null,
      this.props.course.cost
        ? { url: "#cost", text: this.props.t("view.detail.subheadings.cost") }
        : null,
      this.props.course.languages && this.props.course.languages.length > 0
        ? {
            url: "#languages",
            text: this.props.t("view.detail.subheadings.languages"),
          }
        : null,
      (this.props.course.qualifications &&
        this.props.course.qualifications.length > 0) ||
      this.props.course.qualificationUnknown ||
      (this.props.course.manualQualifications &&
        this.props.course.manualQualifications.length > 0)
        ? {
            url: "#qualifications",
            text: this.props.t("view.detail.subheadings.qualifications"),
          }
        : null,
      this.props.course.programme
        ? {
            url: "#programme",
            text: this.props.t("view.detail.subheadings.programme"),
          }
        : null,
      this.props.course.courseType && this.props.course.courseType.length
        ? {
            url: "#courseType",
            text: this.props.t("view.detail.subheadings.courseType"),
          }
        : null,
      this.props.course.sessions && this.props.course.sessions.length
        ? {
            url: "#schedule",
            text: this.props.t("view.detail.subheadings.schedule"),
          }
        : null,
      this.props.venuesCount
        ? {
            url: "#venues",
            text: this.props.t("view.detail.subheadings.venues"),
          }
        : null,
      {
        url: "#contact",
        text: this.props.t("view.detail.subheadings.contact"),
      },
    ];

    contents = contents.filter((item) => item !== null);

    contents.forEach((item, index) => {
      item.text = index + 1 + ". " + item.text;
    });

    return contents;
  }

  addProtocol(url) {
    return !/^(?:f|ht)tps?\:\/\//.test(url) ? `http://${url}` : url;
  }

  render() {
    return (
      <Fragment>
        <Helmet>
          <title>
            {this.props.course.title} | {this.props.t("app.name")}
          </title>
        </Helmet>
        {/* Breadcrumb */}
        <BreadcrumbsItem to={route("results") + this.props.query}>
          {this.props.t("view.results.breadcrumb")}
        </BreadcrumbsItem>

        <BreadcrumbsItem
          to={
            route("detail", {
              course:
                FormUtility.slugify(this.props.course.title) +
                "-" +
                this.props.course.id,
            }) + this.props.query
          }
        >
          {this.props.course.title}
        </BreadcrumbsItem>

        <GelContentContainer>
          <h1>{this.props.course.title}</h1>
          <TopNavigation
            title={this.props.t("view.detail.subheadings.contents")}
            links={this.generateJumpList()}
          />

          {i18n.language === "cy" && (
            <div className="gel-sm-mb-50 gel-sm-mb-50 gel-md-mb-50 gel-lg-mb-50 gel-xl-mb-50">
              <Notice type={"info-icon"}>
                <span>
                  {this.props.t("view.detail.messages.languageDisclaimer")}
                </span>
              </Notice>
            </div>
          )}

          {/* Back to results button */}
          <Button
            url={route("results") + this.props.query}
            theme={["style-dark"]}
            icon={{ type: "chevron-left", position: "left" }}
          >
            {this.props.t("view.detail.controls.backToResults")}
          </Button>

          {/* summary */}
          {this.props.course.summary && (
            <div className="gel-sm-mb-50 gel-sm-mb-50 gel-md-mb-50 gel-lg-mb-50 gel-xl-mb-50">
              <h2 id={"summary"}>
                {this.props.t("view.detail.subheadings.summary")}
              </h2>
              <Sanitize html={this.props.course.summary} />
            </div>
          )}

          {/* content */}
          {this.props.course.content && (
            <div className="gel-sm-mb-50 gel-sm-mb-50 gel-md-mb-50 gel-lg-mb-50 gel-xl-mb-50">
              <h2 id={"content"}>
                {this.props.t("view.detail.subheadings.content")}
              </h2>
              <Sanitize html={this.props.course.content} />
            </div>
          )}

          {/* duration */}
          {this.props.course.duration && (
            <div className="gel-sm-mb-50 gel-sm-mb-50 gel-md-mb-50 gel-lg-mb-50 gel-xl-mb-50">
              <h2 id={"duration"}>
                {this.props.t("view.detail.subheadings.duration")}
              </h2>
              <Sanitize html={this.props.course.duration} />
            </div>
          )}

          {/* entry */}
          {this.props.course.entry && (
            <div className="gel-sm-mb-50 gel-sm-mb-50 gel-md-mb-50 gel-lg-mb-50 gel-xl-mb-50">
              <h2 id={"entry"}>
                {this.props.t("view.detail.subheadings.entry")}
              </h2>
              <Sanitize
                html={this.props.course.entry}
                options={{
                  ALLOWED_TAGS: [
                    "b",
                    "i",
                    "em",
                    "strong",
                    "a",
                    "u",
                    "ul",
                    "li",
                    "ol",
                    "p",
                    "h2",
                    "h3",
                    "h4",
                    "br",
                  ],
                  ALLOWED_ATTR: ["href", "class"],
                }}
              />
            </div>
          )}

          {/* enrolment */}
          {this.props.course.enrolment && (
            <div className="gel-sm-mb-50 gel-sm-mb-50 gel-md-mb-50 gel-lg-mb-50 gel-xl-mb-50">
              <h2 id={"enrolment"}>
                {this.props.t("view.detail.subheadings.enrolment")}
              </h2>
              <Sanitize html={this.props.course.enrolment} />
            </div>
          )}

          {/* additionalDetails */}
          {this.props.course.additionalDetails && (
            <div className="gel-sm-mb-50 gel-sm-mb-50 gel-md-mb-50 gel-lg-mb-50 gel-xl-mb-50">
              <h2 id={"additionalDetails"}>
                {this.props.t("view.detail.subheadings.additionalDetails")}
              </h2>
              <Sanitize html={this.props.course.additionalDetails} />
            </div>
          )}

          {/* cost */}
          {this.props.course.cost && (
            <div className="gel-sm-mb-50 gel-sm-mb-50 gel-md-mb-50 gel-lg-mb-50 gel-xl-mb-50">
              <h2 id={"cost"}>
                {this.props.t("view.detail.subheadings.cost")}
              </h2>
              <Sanitize
                html={this.props.course.cost}
                options={{
                  ALLOWED_TAGS: [
                    "b",
                    "i",
                    "em",
                    "strong",
                    "a",
                    "u",
                    "ul",
                    "li",
                    "ol",
                    "p",
                    "h2",
                    "h3",
                    "h4",
                    "br",
                  ],
                  ALLOWED_ATTR: ["href", "class"],
                }}
              />
            </div>
          )}

          {/* Languages */}
          {this.props.course.languages.length > 0 && (
            <div className="gel-sm-mb-50 gel-sm-mb-50 gel-md-mb-50 gel-lg-mb-50 gel-xl-mb-50">
              <h2 id={"languages"}>
                {this.props.t("view.detail.subheadings.languages")}
              </h2>
              <div>
                {this.props.t("view.detail.fields.languages.label")}{" "}
                {this.props.course.languages
                  .map((language) => {
                    return this.props.filters.languageLookup[language];
                  })
                  .join(", ")}
              </div>
            </div>
          )}

          {/* qualifications */}
          {this.props.course.qualificationUnknown && (
            <div className="gel-sm-mb-50 gel-sm-mb-50 gel-md-mb-50 gel-lg-mb-50 gel-xl-mb-50">
              <h2 id={"qualifications"}>
                {this.props.t("view.detail.subheadings.qualifications")}
              </h2>
              {this.props.filters.qualificationUnknown}
            </div>
          )}

          {((this.props.course.qualifications &&
            this.props.course.qualifications.length > 0) ||
            (this.props.course.manualQualifications &&
              this.props.course.manualQualifications.length > 0)) &&
            !this.props.course.qualificationUnknown && (
              <div className="gel-sm-mb-50 gel-sm-mb-50 gel-md-mb-50 gel-lg-mb-50 gel-xl-mb-50">
                <h2 id={"qualifications"}>
                  {this.props.t("view.detail.subheadings.qualifications")}
                </h2>

                {this.props.course.qualifications &&
                  !!this.props.course.qualifications.length &&
                  this.props.course.qualifications.map((qualification) => {
                    return (
                      <Fragment key={qualification.title}>
                        <GelContentRow>
                          <GelContentColumn xs={12} sm={3}>
                            <p className={"gel-xs-mb-10"}>
                              <strong>
                                {this.props.t(
                                  "view.detail.fields.qualifications.label"
                                )}
                              </strong>
                            </p>
                          </GelContentColumn>
                          <GelContentColumn xs={12} sm={9}>
                            <Sanitize
                              html={qualification.title}
                              classes={["gel-xs-mb-20"]}
                            />
                          </GelContentColumn>
                        </GelContentRow>
                        <GelContentRow>
                          <GelContentColumn xs={12} sm={3}>
                            <p className={"gel-xs-mb-10"}>
                              <strong>
                                {this.props.t(
                                  "view.detail.fields.qualifications.type"
                                )}
                              </strong>
                            </p>
                          </GelContentColumn>
                          <GelContentColumn xs={12} sm={9}>
                            <Sanitize
                              html={
                                this.props.filters.qualificationTypeLookup[
                                  qualification.type
                                ]
                              }
                              classes={["gel-xs-mb-20"]}
                            />
                          </GelContentColumn>
                        </GelContentRow>
                        <GelContentRow>
                          <GelContentColumn xs={12} sm={3}>
                            <p className={"gel-xs-mb-10"}>
                              <strong>
                                {this.props.t(
                                  "view.detail.fields.qualifications.level"
                                )}
                              </strong>
                            </p>
                          </GelContentColumn>
                          <GelContentColumn xs={12} sm={9}>
                            <Sanitize
                              html={
                                this.props.filters.qualificationLevelLookup[
                                  qualification.level
                                ]
                              }
                              classes={["gel-xs-mb-20"]}
                            />
                          </GelContentColumn>
                        </GelContentRow>
                        <GelContentRow>
                          <GelContentColumn xs={12} sm={3}>
                            <p className={"gel-xs-mb-10"}>
                              <strong>
                                {this.props.t(
                                  "view.detail.fields.qualifications.awardingBody"
                                )}
                              </strong>
                            </p>
                          </GelContentColumn>
                          <GelContentColumn xs={12} sm={9}>
                            <Sanitize
                              html={
                                this.props.filters.awardingBodyLookup[
                                  qualification.awardingBody
                                ]
                              }
                              classes={["gel-xs-mb-20"]}
                            />
                          </GelContentColumn>
                        </GelContentRow>
                        <HorizontalRule type={"thin"} />
                      </Fragment>
                    );
                  })}

                {this.props.course.manualQualifications &&
                  !!this.props.course.manualQualifications.length &&
                  this.props.course.manualQualifications.map(
                    (qualification) => {
                      return (
                        <Fragment key={qualification.title}>
                          <GelContentRow>
                            <GelContentColumn xs={12} sm={3}>
                              <p className={"gel-xs-mb-10"}>
                                <strong>
                                  {this.props.t(
                                    "view.detail.fields.qualifications.label"
                                  )}
                                </strong>
                              </p>
                            </GelContentColumn>
                            <GelContentColumn xs={12} sm={9}>
                              <Sanitize
                                html={qualification.title}
                                classes={["gel-xs-mb-20"]}
                              />
                            </GelContentColumn>
                          </GelContentRow>
                          <GelContentRow>
                            <GelContentColumn xs={12} sm={3}>
                              <p className={"gel-xs-mb-10"}>
                                <strong>
                                  {this.props.t(
                                    "view.detail.fields.qualifications.type"
                                  )}
                                </strong>
                              </p>
                            </GelContentColumn>
                            <GelContentColumn xs={12} sm={9}>
                              <Sanitize
                                html={
                                  this.props.filters.qualificationTypeLookup[
                                    qualification.type
                                  ]
                                }
                                classes={["gel-xs-mb-20"]}
                              />
                            </GelContentColumn>
                          </GelContentRow>
                          {!!qualification.level.length && (
                            <GelContentRow>
                              <GelContentColumn xs={12} sm={3}>
                                <p className={"gel-xs-mb-10"}>
                                  <strong>
                                    {this.props.t(
                                      "view.detail.fields.qualifications.level"
                                    )}
                                  </strong>
                                </p>
                              </GelContentColumn>
                              <GelContentColumn xs={12} sm={9}>
                                <Sanitize
                                  html={qualification.level
                                    .map((level) => {
                                      return this.props.filters
                                        .qualificationLevelLookup[level];
                                    })
                                    .join(", ")}
                                  classes={["gel-xs-mb-20"]}
                                />
                              </GelContentColumn>
                            </GelContentRow>
                          )}
                          {qualification.awardingBody && (
                            <GelContentRow>
                              <GelContentColumn xs={12} sm={3}>
                                <p className={"gel-xs-mb-10"}>
                                  <strong>
                                    {this.props.t(
                                      "view.detail.fields.qualifications.awardingBody"
                                    )}
                                  </strong>
                                </p>
                              </GelContentColumn>
                              <GelContentColumn xs={12} sm={9}>
                                <Sanitize
                                  html={
                                    this.props.filters.awardingBodyLookup[
                                      qualification.awardingBody
                                    ]
                                  }
                                  classes={["gel-xs-mb-20"]}
                                />
                              </GelContentColumn>
                            </GelContentRow>
                          )}
                          <HorizontalRule type={"thin"} />
                        </Fragment>
                      );
                    }
                  )}
              </div>
            )}

          {/* programme */}
          {this.props.course.programme && (
            <div className="gel-sm-mb-50 gel-sm-mb-50 gel-md-mb-50 gel-lg-mb-50 gel-xl-mb-50">
              <h2 id={"programme"}>
                {this.props.t("view.detail.subheadings.programme")}
              </h2>
              <p>
                {
                  this.props.filters.programmeLookup[
                    this.props.course.programme
                  ].name
                }
              </p>
            </div>
          )}

          {/* courseType */}
          {this.props.course.courseType.length > 0 && (
            <div className="gel-sm-mb-50 gel-sm-mb-50 gel-md-mb-50 gel-lg-mb-50 gel-xl-mb-50">
              <h2 id={"courseType"}>
                {this.props.t("view.detail.subheadings.courseType")}
              </h2>

              {this.props.course.courseType.map((language) => {
                return (
                  <Fragment key={language}>
                    {this.props.filters.courseTypeLookup[language]} <br />{" "}
                  </Fragment>
                );
              })}
            </div>
          )}

          {/* Schedule */}
          {!!this.props.course.sessions.length && (
            <Fragment>
              <div className="gel-sm-mb-50 gel-sm-mb-50 gel-md-mb-50 gel-lg-mb-50 gel-xl-mb-50">
                <h2 id={"schedule"}>
                  {this.props.t("view.detail.subheadings.schedule")}
                </h2>

                {this.props.course.sessions.map((session, sessionIndex) => {
                  if (session.venues && session.venues.length) {
                    return (
                      session.venues &&
                      session.venues.map((venue, venueIndex) => {
                        return (
                          <DetailViewSchedule
                            {...this.props}
                            venue={venue}
                            session={session}
                          />
                        );
                      })
                    );
                  } else {
                    return (
                      <DetailViewSchedule
                        {...this.props}
                        venue={false}
                        session={session}
                      />
                    );
                  }
                })}
              </div>

              {/* Venues */}
              {this.props.venuesCount > 0 && (
                <div className="gel-sm-mb-50 gel-sm-mb-50 gel-md-mb-50 gel-lg-mb-50 gel-xl-mb-50">
                  <h2 id={"venues"}>
                    {this.props.t("view.detail.subheadings.venues")}
                  </h2>
                  <Accordion
                    // If hash ID is a venue ID (i.e. 36 characters in length so as to exclude #venues) then set as open by default.
                    defaultOpen={this.props.location.hash.replace('#','').length === 36 ? this.props.location.hash.replace('#','') : undefined}
                    items={this.props.course.sessions
                      .map((session, sessionIndex) => {
                        return session.venues.map((venue, venueIndex) => {
                          return {
                            id: venue.id,
                            title: venue.name,
                            body: (
                              <Fragment>
                                <p>
                                  {[
                                    venue.addressLine1,
                                    venue.addressLine2,
                                    venue.addressLine3,
                                    venue.addressLine4,
                                    venue.townCity,
                                    venue.county,
                                    venue.postCode,
                                  ]
                                    .filter((e) => e)
                                    .join(", ")}
                                </p>

                                {venue.latLong && (
                                  <p>
                                    <a
                                      href={
                                        "https://maps.google.com/?q=" +
                                        venue.latLong.replace(/ /g, "")
                                      }
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="style--icon-pin"
                                    >
                                      {this.props.t(
                                        "view.detail.fields.map.label",
                                        { venue: venue.name }
                                      )}
                                    </a>
                                  </p>
                                )}

                                {venue.extraFacilities && (
                                  <GelContentRow>
                                    <GelContentColumn xs={12} sm={3}>
                                      <p>
                                        <strong>
                                          {this.props.t(
                                            "view.detail.fields.extraFacilities.label"
                                          )}
                                          :
                                        </strong>
                                      </p>
                                    </GelContentColumn>
                                    <GelContentColumn xs={12} sm={9}>
                                      <p> {venue.extraFacilities}</p>
                                    </GelContentColumn>
                                  </GelContentRow>
                                )}

                                {venue.facilitiesAvailable &&
                                  venue.facilitiesAvailable.length > 0 && (
                                    <GelContentRow>
                                      <GelContentColumn xs={12} sm={3}>
                                        <p>
                                          <strong>
                                            {this.props.t(
                                              "view.detail.fields.facilitiesAvailable.label"
                                            )}
                                            :
                                          </strong>
                                        </p>
                                      </GelContentColumn>
                                      <GelContentColumn xs={12} sm={9}>
                                        <p>
                                          {venue.facilitiesAvailable
                                            .map((facility, venueIndex) => {
                                              return this.props.filters
                                                .facilitiesAvailableLookup[
                                                facility
                                              ];
                                            })
                                            .join(", ")}
                                        </p>
                                      </GelContentColumn>
                                    </GelContentRow>
                                  )}

                                {venue.learnerSupport &&
                                  venue.learnerSupport.length > 0 && (
                                    <GelContentRow>
                                      <GelContentColumn xs={12} sm={3}>
                                        <p>
                                          <strong>
                                            {this.props.t(
                                              "view.detail.fields.learnerSupport.label"
                                            )}
                                            :
                                          </strong>
                                        </p>
                                      </GelContentColumn>
                                      <GelContentColumn xs={12} sm={9}>
                                        <p>
                                          {venue.learnerSupport
                                            .map((support, venueIndex) => {
                                              return this.props.filters
                                                .learnerSupportLookup[support];
                                            })
                                            .join(", ")}
                                        </p>
                                      </GelContentColumn>
                                    </GelContentRow>
                                  )}
                              </Fragment>
                            ),
                          };
                        });
                      })
                      .flat(1)
                      .filter(
                        (v, i, a) => a.findIndex((v2) => v2.id === v.id) === i
                      )}
                  />
                </div>
              )}
            </Fragment>
          )}

          {/* Back to schedule button */}
          <ButtonSecondary
            icon={{ type: "chevron-up", position: "left" }}
            url={"#schedule"}
          >
            {this.props.t("view.detail.controls.backToSchedule")}
          </ButtonSecondary>

          {/* Provider contact details */}
          <div className="gel-sm-mb-50 gel-sm-mb-50 gel-md-mb-50 gel-lg-mb-50 gel-xl-mb-50">
            <h2 id={"contact"}>
              {this.props.t("view.detail.subheadings.contact")}
            </h2>
            <p>
              <strong>
                {this.props.course.provider.cw_courseprovidername?.toUpperCase()}
              </strong>
            </p>
            {this.props.course.provider.addressLine1 && (
              <div>
                <p className="gel-xs-mb-10">
                  {[
                    this.props.course.provider.addressLine1,
                    this.props.course.provider.addressLine2,
                    this.props.course.provider.addressLine3,
                    this.props.course.provider.addressLine4,
                    this.props.course.provider.townCity,
                    this.props.course.provider.county,
                    this.props.course.provider.postCode,
                  ]
                    .filter((e) => e)
                    .join(", ")}
                </p>
              </div>
            )}
            {this.props.course.provider.website && (
              <div>
                <p className="gel-xs-mb-10 style--icon-website icon--large">
                  <a
                    href={this.addProtocol(this.props.course.provider.website)}
                    target={"_blank"}
                  >
                    {this.props.course.provider.website}
                  </a>
                </p>
              </div>
            )}
            {this.props.course.provider.phone && (
              <div>
                <p className="gel-xs-mb-10 style--icon-phone icon--large">
                  <a
                    href={`tel:${this.props.course.provider.phone}`}
                    rel="noopener noreferrer"
                  >
                    {this.props.course.provider.phone}
                  </a>
                </p>
              </div>
            )}
            {this.props.course.provider.email && (
              <div>
                <p className="gel-xs-mb-10 style--icon-email icon--large gel-wrap">
                  <a
                    href={"mailto:" + this.props.course.provider.email}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {this.props.course.provider.email}
                  </a>
                </p>
              </div>
            )}
            <p>{this.props.contractor}</p>
          </div>

          <div className="gel-sm-mb-50 gel-sm-mb-50 gel-md-mb-50 gel-lg-mb-50 gel-xl-mb-50">
            <Notice type={"info-icon"}>
              <span>
                {this.props.t("view.detail.messages.accuracyDisclaimer")}
              </span>
            </Notice>
          </div>

          <Button
            url={route("results") + this.props.query}
            theme={["style-dark"]}
            icon={{ type: "chevron-left", position: "left" }}
          >
            {this.props.t("view.detail.controls.backToResults")}
          </Button>
        </GelContentContainer>
      </Fragment>
    );
  }
}

export default withRouter(withTranslation("local")(DetailView));
